"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isControlEnergy = exports.isFluctuating = exports.isCoLocation = exports.isBiomass = exports.isWater = exports.isBattery = exports.isWind = exports.isSolar = exports.isCogeneration = exports.isBiogas = void 0;
const types_1 = require("../../types/types");
function isBiogas(technologies) {
    const technologySet = new Set(technologies);
    return technologySet.size === 1 && technologySet.has(types_1.MachineTechnology.BIOGAS);
}
exports.isBiogas = isBiogas;
function isCogeneration(technologies) {
    const technologySet = new Set(technologies);
    return technologySet.size === 1 && technologySet.has(types_1.MachineTechnology.CONVENTIONAL);
}
exports.isCogeneration = isCogeneration;
function isSolar(technologies) {
    const technologySet = new Set(technologies);
    return technologySet.size === 1 && technologySet.has(types_1.MachineTechnology.SOLAR);
}
exports.isSolar = isSolar;
function isWind(technologies) {
    const technologySet = new Set(technologies);
    return technologySet.size === 1 && technologySet.has(types_1.MachineTechnology.WIND);
}
exports.isWind = isWind;
function isBattery(technologies) {
    const technologySet = new Set(technologies);
    return technologySet.size === 1 && technologySet.has(types_1.MachineTechnology.BATTERY);
}
exports.isBattery = isBattery;
function isWater(technologies) {
    const technologySet = new Set(technologies);
    return technologySet.size === 1 && technologySet.has(types_1.MachineTechnology.WATER);
}
exports.isWater = isWater;
function isBiomass(technologies) {
    const technologySet = new Set(technologies);
    return technologySet.size === 1 && technologySet.has(types_1.MachineTechnology.BIOMASS);
}
exports.isBiomass = isBiomass;
function isCoLocation(technologies) {
    const technologySet = new Set(technologies);
    return technologySet.size !== 1 && technologySet.has(types_1.MachineTechnology.BATTERY);
}
exports.isCoLocation = isCoLocation;
function isFluctuating(technologies) {
    return isSolar(technologies) || isWind(technologies);
}
exports.isFluctuating = isFluctuating;
function isControlEnergy(technologies) {
    return isCogeneration(technologies) || isBattery(technologies);
}
exports.isControlEnergy = isControlEnergy;
